import { Category } from '@sulis-liiga/common';

// ─── Category slug ↔ Category enum ───────────────────────────────────────────
// Shared URL slug maps for the per-category division routes
// (`/leagues/:leagueId/divisions/:category[/manage]`). Lives here (rather than on
// a page) so both pages and shared components can import it without a page→component
// dependency.

export const CATEGORY_SLUGS: Record<string, Category> = {
  'mens-singles': Category.MENS_SINGLES,
  'mens-doubles': Category.MENS_DOUBLES,
  'womens-singles': Category.WOMENS_SINGLES,
  'womens-doubles': Category.WOMENS_DOUBLES,
  'mixed-doubles': Category.MIXED_DOUBLES,
};

export const CATEGORY_TO_SLUG: Record<Category, string> = {
  [Category.MENS_SINGLES]: 'mens-singles',
  [Category.MENS_DOUBLES]: 'mens-doubles',
  [Category.WOMENS_SINGLES]: 'womens-singles',
  [Category.WOMENS_DOUBLES]: 'womens-doubles',
  [Category.MIXED_DOUBLES]: 'mixed-doubles',
};
